import { isKeyOf } from '@sofa-platform/types'

import masterCopy from './master-copy.json'

export type SofaTranslation = Record<TranslationKey, string>

export type TranslationKey = keyof RawSofaTranslation

type RawSofaTranslation = typeof masterCopy

export function getTranslationByKey(path: TranslationKey, obj?: object): string {
  if (!obj) {
    return masterCopy[path].message
  }
  return _getTranslationByPath(path, obj)
}

function _getTranslationByPath(path: TranslationKey, obj: object): string {
  const keys = path.split('.')
  // biome-ignore lint/suspicious/noExplicitAny: dynamic path traversal requires any
  let acc: any = obj

  for (const k of keys) {
    if (acc == null) break
    acc = acc[k]
  }

  if (typeof acc !== 'string') {
    if (isKeyOf(path, masterCopy)) return masterCopy[path].message
    // Fallback to key in case of missing translation
    return path
  }
  return acc
}
